import classNames from "classnames/bind";
import styles from "./VerticalNavDots.module.css";

const cx = classNames.bind(styles);

export function VerticalNavDots({
  className,
  activeIndex,
  dotsCount,
  onClickDot,
}: {
  className?: string;
  activeIndex: number;
  dotsCount: number;
  onClickDot?: (index: number) => void;
}) {
  return (
    <div className={cx("container", className)}>
      {new Array(dotsCount).fill(undefined).map((card, index) => (
        <button
          key={index}
          aria-current={activeIndex === index}
          onClick={onClickDot ? () => onClickDot(index) : undefined}
          className={cx("dot")}
          aria-label={`Slide ${index + 1}`}
        ></button>
      ))}
    </div>
  );
}
